import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class HelpCenterIcon extends React.Component<ISvgIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M12.7,13c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.2,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2
                        c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.3c0.2,0.2,0.4,0.3,0.7,0.2
                        c0.1,0,0.2,0,0.3-0.1s0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3s0-0.2-0.1-0.3C12.8,13.2,12.7,13.1,12.7,13z"
                        />
                    <path d="M9.8,7.8C9.9,7.9,10.1,8,10.3,8s0.3-0.1,0.4-0.2C11,7.3,11.5,7.1,12,6.9c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0.1,0.4,0.2
                        c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0,0.2,0,0.3-0.1,0.5s-0.1,0.3-0.3,0.4S12.5,8.9,12.4,9C12.2,9,12.1,9,11.9,9
                        c-0.2,0-0.3,0.1-0.5,0.2s-0.2,0.3-0.2,0.5v1.1c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0,0.4-0.1,0.5-0.3
                        s0.2-0.3,0.2-0.5v-0.3c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0.5-0.2,1-0.6,1.3-1.2c0.3-0.5,0.4-1.1,0.2-1.7
                        c-0.1-0.6-0.4-1.1-0.9-1.5c-0.5-0.4-1-0.6-1.6-0.6c-0.5,0-0.9,0.2-1.3,0.4c-0.4,0.2-0.7,0.5-1,0.9C9.5,6.8,9.4,7,9.5,7.2
                        S9.6,7.7,9.8,7.8L9.8,7.8z"/>
                    <path d="M20,0.2H4c-2.2,0-4,1.8-4,4l0,11.6c0,2.2,1.8,4,4,4h0c0,0.9,0,2.7,0,3.1C4,23,4,23.1,4,23.2c0,0.1,0.1,0.2,0.2,0.3
                        c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0.1,0.3,0.1c0,0,0.1,0,0.1,0c0.5,0,0.9-0.2,1.2-0.4c0.5-0.3,1-1,1.6-1.7c0.6-0.7,1.3-1.5,1.9-2
                        l10.3,0c2.2,0,4-1.8,4-4l0-11.5C24,2,22.2,0.2,20,0.2z M22.5,1.6L22.5,1.6L22.5,1.6L22.5,1.6C22.5,1.6,22.5,1.6,22.5,1.6z
                        M22.3,4.3v11.2c0,1.4-1.1,2.5-2.5,2.5H9.2l-0.4,0.3C8,19,7.2,19.8,6.5,20.7c-0.3,0.4-0.6,0.7-0.9,1c0-0.8,0-1.8,0-2.3l0-1.4
                        l-1.4,0c-1.4,0-2.5-1.1-2.5-2.5V4.3c0-1.4,1.1-2.5,2.5-2.5h15.7C21.2,1.8,22.3,2.9,22.3,4.3z"/>
                </g>
            </SvgIcon>
        );
    }
}
